<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Foreword</h1>
</div>
</div>
<h1>
	Foreword</h1>
<p class="first">
	In December of 1135, Henry I died, plunging England into a civil war that would last nineteen years. Earlier, after the death of his only legitimate son and heir, Henry had chosen his daughter, Mathilda, to follow him on the throne, and he had forced a reluctant baronage to swear fealty to her on two separate occasions. Unfortunately, when she’d been widowed as Holy Roman Empress, he’d contracted a second marriage for her with Geoffrey of Anjou, a marriage that was highly unpopular in both England and Normandy. And, on his death, there were few who wished to be ruled by her Angevin husband.</p>
<p>
	This set the stage for the rise of other contenders for the English throne, most particularly two of Henry I’s nephews, Theobald, Count of Blois, and his younger brother, Stephen of Blois, Count of Mortain and Boulogne. Some of the baronage even preferred Henry’s favorite bastard son, Robert, Earl of Gloucester, over “the Empress,” as Matilda was usually called. The strongest personal rivalry existed between Stephen of Blois and Robert of Gloucester, the two greatest land-holding magnates in the realm, each of whom possessed nearly one-half million acres of English land, and each of whom had loyalists ready to argue his claim.</p>
<p>
	My story opens as the Norman barons were preparing to bypass Mathilda and offer the crown to Count Theobald. But Stephen, not to be outfaced, had rushed to England, enlisted the aid of yet another brother, Bishop Henry of Winchester, taken possession of the royal seal and treasury, and persuaded the Curia Regis, a body comprising for the most part ranking clergymen, to declare him king. He was helped immeasurably by the perjury of another baron, Hugh Bigod, who swore that the king had repudiated his daughter on his deathbed and named Stephen as his heir. Robert of Gloucester, the one man who could refute his testimony, remained in Normandy with his father’s body.</p>
<p>
	Almost immediately, the rival factions supporting Stephen, Mathilda, and Robert quarreled over the Curia’s selection, and Stephen began his reign over lands fast dissolving into anarchy. The England which had been for the most part at peace during Henry I’s long reign was wracked by the armed conflict of those who supported causes and those who sought merely to profit from the unrest. It was the beginning of what one chronicler called “nineteen long winters” of civil war.</p>
<p>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap139416.vue?5fab6f9a